export enum BusinessMaternityCoverage {
  DURATION_EXTENSION = 'DURATION_EXTENSION',
  FULL_SALARY_COVERAGE = 'FULL_SALARY_COVERAGE',
  PRIVATE_SEMI_PRIVATE_BIRTH = 'PRIVATE_SEMI_PRIVATE_BIRTH',
}

export const BUSINESS_MATERNITY_COVERAGE_VALUES = Object.values(
  BusinessMaternityCoverage
);

export const getBusinessMaternityCoverageLabel = (
  value: BusinessMaternityCoverage
) => {
  switch (value) {
    case BusinessMaternityCoverage.DURATION_EXTENSION:
      return $localize`Prolongation de la durée`;
    case BusinessMaternityCoverage.FULL_SALARY_COVERAGE:
      return $localize`Couverture du salaire à 100%`;
    case BusinessMaternityCoverage.PRIVATE_SEMI_PRIVATE_BIRTH:
      return $localize`Accouchement en divisionprivée ou semi-privée`;
  }
};
